import FunnelModuleDescription from "./FunnelModuleDescription";
import "./ModuleLockedLayout.scss";

interface ModuleLockedLayoutProps {
  moduleId: string;
  moduleName: string;
  fallbackDescription?: string;
}

/**
 * Wird angezeigt, wenn ein Modul für den aktuellen Tenant nicht freigeschaltet ist.
 * Zeigt die personalisierte Modulbeschreibung als Hauptinhalt an.
 */
export default function ModuleLockedLayout({
  moduleId,
  moduleName,
  fallbackDescription,
}: ModuleLockedLayoutProps) {
  return (
    <div className="module-locked">
      <div className="module-locked__card">
        <div className="module-locked__icon-wrapper">
          <span className="module-locked__icon">🔒</span>
        </div>

        <div className="module-locked__content">
          <h2 className="module-locked__title">{moduleName}</h2>

          <FunnelModuleDescription
            moduleId={moduleId}
            fallback={fallbackDescription}
            className="module-locked__description"
          />

          <div className="module-locked__hint">
            Dieses Modul ist für deinen Account noch nicht freigeschaltet.
            Kontaktiere uns, um Zugang zu erhalten.
          </div>
        </div>

        <div className="module-locked__actions">
          <a
            href="mailto:support@aaglobalreach.de"
            className="module-locked__cta"
          >
            Modul freischalten
          </a>
        </div>
      </div>
    </div>
  );
}
